// extracted by mini-css-extract-plugin
export default {"tableNumberBody":"style_tableNumberBody__b9JNt","tableNumber":"style_tableNumber__P64pw"};